export default {
  cashback: {
    title: 'Bewerte uns & erhalte',
    description: '{{value}} Punkte ({{moneyValue}})',
  },
  product_suggestions: {
    title: 'Bewerte uns & erhalte',
    description: '1 Gratis {{product}} & mehr',
    types: {
      free_reward: {
        message_default: 'Bewerte uns & erhalte 1 gratis {{product}}',
        message_short: 'Erhalte 1 gratis {{product}}',
        message_reward: 'Gratis {{product}}',
        message_reward_prefix: '1 Gratis {{product}}',
      },
      multiple_free_rewards: {
        message_default: 'Bewerte uns & erhalte 1 gratis {{product}} & mehr',
        message_short: 'Erhalte 1 gratis {{product}} & mehr',
        message_reward: 'Gratis {{product}} & mehr',
        message_reward_prefix: '1 Gratis {{product}} & mehr',
      },
      discount: {
        message_default: 'Bewerte uns & erhalte {{discount}}% Rabatt nächste Bestellung',
        message_short: 'Erhalte {{discount}}% Rabatt nächste Bestellung',
        message_reward: '{{discount}}% Rabatt',
        message_reward_prefix: '{{discount}}% Rabatt',
      },
    },
    points: '{{count}} pts',
  },
};
